const audio = new Audio('/static/play.wav');
audio.preload = 'auto';

let unlocked = false;

const unlock = () => {
  if (unlocked) return;
  audio.volume = 0;
  audio.play()
    .then(() => {
      audio.pause();
      audio.currentTime = 0;
      audio.volume = 1;
      unlocked = true;
    })
    .catch(() => {});
};

document.addEventListener('click', unlock, true);
document.addEventListener('keydown', unlock, true);
document.addEventListener('touchstart', unlock, true);

export const playNotificationSound = () => {
  audio.currentTime = 0;
  audio.play().catch(() => {});
};
